import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { fetchAllRadiologistsAPI } from '../../../services/radiologists-service';
import { FETCH_ALL_RADIOLOGISTS, FETCH_ALL_RADIOLOGISTS_ERROR, FETCH_ALL_RADIOLOGISTS_SUCCESS } from '../../actions/receptionist/radiologistsAction'


function* fetchAllRadiologists({ }) {
    try {
        const response = yield call(fetchAllRadiologistsAPI);

        if (response.success) {
            yield put({ type: FETCH_ALL_RADIOLOGISTS_SUCCESS, radiologists: [...response.data] })
        } else {
            yield put({ type: FETCH_ALL_RADIOLOGISTS_ERROR, error: response.error })
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_RADIOLOGISTS_ERROR, error })
    }
}



function* radiologistsWatcher() {
    yield takeLatest(FETCH_ALL_RADIOLOGISTS, fetchAllRadiologists)

}

export default function* rootSaga() {
    yield all([radiologistsWatcher()])
}